<template>
    <div>
        <el-card class="box-card" shadow="never">
            <el-row :gutter="10">
                <div class="search-title">
                    仪表通断详情
                </div>
                <div class="search-input-item">
                    <el-date-picker
                    v-model="query.dataRange"
                    type="daterange"
                    align="right"
                    size="small"
                    style="width: 410px"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div class="search-button-tools">
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.openCloseRecords'" :loading="tableLoading" @click="doSearch">查询</el-button>
                    <el-button size="small" type="primary" @click="doClose">关闭</el-button>
                </div>
                <el-table  
                :data="tableData"
                row-key="id" 
                border
                v-loading="tableLoading"
                tooltip-effect="light"
                :stripe="true">
                    <el-table-column width="150" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
                    <el-table-column width="80" prop="meterType" label="类型"></el-table-column>
                    <el-table-column width="80" prop="openClose" label="指令">
                        <template slot-scope="scope">
                            <span>{{scope.row.openClose == 'open'? '送电': '断电'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" prop="createDate" label="指令发送时间"></el-table-column>
                    <el-table-column width="200" show-overflow-tooltip prop="msg" label="发送结果"></el-table-column>
                    <el-table-column width="180" prop="backDate" label="指令执行时间"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip prop="backRes" label="执行结果"></el-table-column>
                    <el-table-column prop="remarks" label="备注"></el-table-column>
                </el-table>
                <simple-pagination @search="doSearch" />
            </el-row>
        </el-card>
    </div>
</template>

<script>
import '@/assets/scss/common.scss';
import mixin from '@/mixin/index';
import dlg from '@/mixin/dlg';
export default {
    name: "OpenCloseDetailTable",
    mixins: [mixin, dlg],
    props: {
        meterId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            queryListUrl: 'meter/web/control/listPage',
        }
    },
    methods: {
        doSearch() {
            this.getList();
        },
    },
    mounted() {
        if(this.meterId) {
            this.query.meterId = this.meterId;
            this.doSearch();
        }
    }
}
</script>